import { Telescope, PenLine, Tag, BookOpen, PenTool, Clock } from "lucide-react";
import { useTranslation } from "react-i18next";

const PREFS = [
    { id: "similar", icon: Telescope },
    { id: "same_style", icon: PenLine },
    { id: "same_topic", icon: Tag },
    { id: "same_author", icon: PenTool },
    { id: "same_era", icon: Clock },
    { id: "by_pages", icon: BookOpen },
];

export default function PreferenceSelector({ value, onChange, pagesValue, onPagesChange }) {
    const { t } = useTranslation();
    return (
        <div className="w-full">
            <div className="flex flex-wrap justify-center gap-3" role="radiogroup">
                {PREFS.map((p) => {
                    const Icon = p.icon;
                    const active = value === p.id;
                    return (
                        <button
                            key={p.id}
                            data-testid={`preference-toggle-${p.id}`}
                            type="button"
                            role="radio"
                            aria-checked={active}
                            onClick={() => onChange(p.id)}
                            className={`group flex items-center gap-2 rounded-full border px-5 py-2.5 text-sm transition-all ${
                                active
                                    ? "bg-[var(--ink)] text-[var(--bg)] border-[var(--ink)]"
                                    : "bg-transparent text-[var(--ink-muted)] border-[var(--border-strong)] hover:border-[var(--ink)] hover:text-[var(--ink)] hover:bg-[var(--bg-hover)]"
                            }`}
                        >
                            <Icon size={14} strokeWidth={1.5} />
                            <span>{t(`preference.${p.id}`)}</span>
                        </button>
                    );
                })}
            </div>

            {value === "by_pages" && (
                <div
                    data-testid="pages-options"
                    className="flex flex-wrap justify-center gap-2 mt-5 animate-fade-up"
                >
                    {["short", "medium", "long"].map((id) => (
                        <button
                            key={id}
                            data-testid={`pages-option-${id}`}
                            type="button"
                            onClick={() => onPagesChange(id)}
                            className={`rounded-full border px-4 py-1.5 text-xs uppercase tracking-widest transition-all ${
                                pagesValue === id
                                    ? "bg-[var(--accent)] text-[var(--bg)] border-[var(--accent)]"
                                    : "bg-transparent text-[var(--ink-muted)] border-[var(--border-strong)] hover:border-[var(--ink)] hover:text-[var(--ink)]"
                            }`}
                        >
                            {t(`pages.${id}`)}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
